import { profileInfo as userInfo } from "../actions/user";
import { profileInfo as adminInfo } from "../actions/admin";

/**
 * utils for profile
 */
class ProfileUtils {
    /**
     * put data in profile card
     * @private
     * @param {Object} user_data
     * @param {JQuery} $profile_card
     */
    static #showUserInfo(user_data, $profile_card) {
        $(".impersonate_name").text(user_data.first_name + " " + user_data.last_name);
        if ($profile_card) {
            if (user_data.avatar) {
                $profile_card
                    .find(".profile_card_avatar")
                    .attr("src", user_data.avatar);
            }
            $profile_card.find(".profile_card_name").text(`
                ${user_data.first_name ? user_data.first_name : "کاربر"} ${
    user_data.last_name ? user_data.last_name : ""
}
            `);
        }
    }

    /**
     * Show user first_name, last_name and avatar in profile card
     * @param {"my" | "admin"} destination which domain?
     * @param {JQuery | null} $profile_card jquery element of profile card
     */
    static showProfileCardData(destination, $profile_card = null) {
        const session_user_data = JSON.parse(sessionStorage.getItem("UD"));
        if (session_user_data && session_user_data.first_name) {
            this.#showUserInfo(session_user_data, $profile_card);
        } else {
            if (destination === "my") {
                userInfo().then((info) => {
                    const user_data = {
                        first_name: info.first_name ? info.first_name : null,
                        last_name: info.last_name ? info.last_name : null,
                        date:
                            info &&
                            "attributes" in info &&
                            info.attributes &&
                            "accept_agreement" in info.attributes &&
                            info.attributes.accept_agreement ?
                                info.attributes.accept_agreement :
                                null,
                        avatar:
                            info &&
                            "attributes" in info &&
                            info.attributes &&
                            "avatar" in info.attributes &&
                            info.attributes.avatar ?
                                info.attributes.avatar :
                                null,
                        national_code: info.national_code ?
                            info.national_code :
                            null,
                        msisdn: info.msisdn ? info.msisdn : null,
                        birthDay: "sejam_birthday" in info ? info.sejam_birthday : null
                    };

                    sessionStorage.setItem("UD", JSON.stringify(user_data));
                    window.dispatchEvent(new Event("UD-SET"));
                    this.#showUserInfo(user_data, $profile_card);
                });
            } else if (destination === "admin") {
                adminInfo().then((info) => {
                    const admin_data = {
                        first_name: info.first_name ? info.first_name : null,
                        last_name: info.last_name ? info.last_name : null,
                        avatar: info.attributes.avatar ?
                            info.attributes.avatar :
                            null,
                    };

                    sessionStorage.setItem("UD", JSON.stringify(admin_data));
                    window.dispatchEvent(new Event("UD-SET"));
                    this.#showUserInfo(admin_data, $profile_card);
                });
            }
        }
    }

    /**
     *
     * @return {{first_name: string, last_name:string, avatar: string, national_code: string, msisdn: string}}
     */
    static getUserInfo() {
        const session_user_data = sessionStorage.getItem("UD");
        if (session_user_data) {
            return JSON.parse(session_user_data);
        } else {
            userInfo().then((info) => {
                const user_data = {
                    first_name: info.first_name ? info.first_name : null,
                    last_name: info.last_name ? info.last_name : null,
                    avatar: info.attributes.avatar ?
                        info.attributes.avatar :
                        null,
                    national_code: info.national_code ?
                        info.national_code :
                        null,
                    msisdn: info.msisdn ? info.msisdn : null,
                };
                
                sessionStorage.setItem("UD", JSON.stringify(user_data));
                window.dispatchEvent(new Event("UD-SET"));
                return user_data;
            });
        }
    }
}

export { ProfileUtils };
